import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
export default function BUHBudgetTable({rows,Month1,Month2,Month3}) {

const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },
  {
    field: 'prodcode',
    headerName: 'Prod code',
    width: 90,
    sortable: false,
  },
  {
    field: 'proddesc',
    headerName: 'Product Description',
    width: 225,
    sortable: false,
  },
  {
    field: 'proxycode',
    headerName: 'Proxy code',
    width: 90,
    sortable: false,
  },
  {
    field: 'brand',
    headerName: 'Brand',
    width: 160,
    sortable: false,
  },
  {
    field: 'm1_qty',
    headerName: String(Month1)+' U',
    width: 150,
    sortable: true,
    align:'center',

  },
  {
    field: 'm1_value',
    headerName: String(Month1)+' V',
    width: 150,
    sortable: true,
    align:'center',

  },
  {
    field: 'm1_nsp',
    headerName: String(Month1)+' NSP',
    width: 150,
    sortable: true,
    align:'center',
    hide:true,

  },
  {
    field: 'm2_qty',
    headerName: 'M2 Quantity',
    headerName: String(Month2)+' U',

    width: 150,
    sortable: true,
    align:'center'
  },
  {
    field: 'm2_value',
    headerName: String(Month2)+' V',
    width: 150,
    sortable: true,
    align:'center'
  },
  {
    field: 'm2_nsp',
    headerName: String(Month2)+' NSP',
    width: 150,
    sortable: true,
    align:'center'
  },
  {
    field: 'm3_qty',
    headerName: String(Month3)+' U',
    width: 150,
    sortable: true,
    align:'center'
  },
  {
    field: 'm3_value',
    headerName: String(Month3)+' V',
    width: 150,
    sortable: true,
    align:'center'
  },
  {
    field: 'm3_nsp',
    headerName: String(Month3)+' NSP',
    width: 150,
    sortable: true,
    align:'center'
  },
  
  
];


  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1}
        Month2={Month2} 
        Month3={Month3}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[15]}
        density='compact'
      />
    </div>
  );
}
